import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'boolToString',
    standalone: false
})
export class BooleanToStringPipe implements PipeTransform {

  transform(value: string): string {
    return !!value ? 'Yes' : 'No';
  }

}